import { getConfig } from 'config/envVars'
import NoSSR from 'react-no-ssr'
import * as contentStyles from '../../styles/content.module.css'

const config = getConfig()

const AboutView = () => <div className={contentStyles.contentView}>
  <div className={contentStyles.contentTitleRow}>
    <h1>Hi! My name is&nbsp;Matt.</h1>
    <div className={contentStyles.contentTitlePhotoWrapper}>
      <div className={contentStyles.contentTitlePhoto}>
          <img alt='Picture of Matt' width={181} src={`${config.imageHostname}matt_ice_cream.jpg`} />
      </div>
      <div className={contentStyles.contentTitlePhotoCaption}>NOT a professional photo</div>
    </div>
  </div>
  <br />
  <h2>I’m the founder, lead engineer, head designer, and front-line customer support agent at&nbsp;CardHero.</h2>
  <p>I’m also a husband and dad. I live in the Hudson Valley in New York with my wonderful wife, two wonderful kids, and two wonderful cats. Strong possibility of adding a wonderful dog soon.</p>
  <p>CardHero was born from a moment. I was staring at yet another bland, off-white cliché, and I was sweating a bit.</p>
  <p>It was Tuesday, February 13th, 2018, and, yes, it was the day before Valentine’s. I knew it was late in the game, but work had been wild and I just hadn’t had even a minute to run to the store.</p>
  <p>At last, I was at the pharmacy near my home, searching the aisle for an acceptable card for my wife. Needless to say, the good options were long sold out. I spent 23 minutes (23!) going back and forth. Finally I settled – emphasis on <i>SETTLED</i> – on something I thought my wife <i>might</i> half-smile at.</p>
  <p>I went to pay at the cashier and the card cost nearly $8!</p>
  {/* <p>Getting a Valentine's, anniversary, or birthday card for someone you love shouldn't be a headache. It should be fun and easy.</p> */}
  <br />
  <h2>I started CardHero because I knew there had to be a better way to get a card for my&nbsp;wife.</h2>
  <p>A faster way. An easier way. And, most importantly, a way where I found <strong>a card I was actually excited to give her</strong>.</p>
  <p>I hope CardHero can be that for you, too.</p>
  <p>- <strong>Matt</strong><br />
    <NoSSR>
      <span className={contentStyles.hidden}>- </span>matt@<span className={contentStyles.addrBit}>welcometo</span>thecardhero.com
    </NoSSR>
  </p>

</div>

export default AboutView
